<!--
패키지 하나를 의미하는 컴포넌트
-->
<template>
    <!-- 패키지 -->
    <div class="uk-flex uk-flex-top uk-flex-left">

        <!-- 필수값 강조 -->
        <div v-show="! hasWeight" class="input-msg" @click="$parent.editPackage(index)">
            <!-- 무게 미입력 안내화면 -->
            <slot name="empty-screen" >
                CLICK! 무게(부피)를 입력하세요.
            </slot>

        </div>

        <div
            class="package uk-width-expand uk-flex uk-flex-between"
            v-on:click="$parent.editPackage(index)"

            v-show="hasWeight"
        >
            <!-- 무게/부피-->
            <div class="cell weight">
                <h4>무게</h4>

                <span class="value">{{ package.weight }}</span>
                <span class="unit">{{ unit }}</span>

            </div>

            <div class="cell volume_x">
                <h4>가로</h4>
                <span class="value">
                        {{ package.volume_x }}
                    </span>
                <span class="unit">{{ volumeUnit }}</span>
            </div>

            <div class="cell volume_y">
                <h4>세로</h4>
                <span class="value">
                        {{ package.volume_y }}
                    </span>
                <span class="unit">{{ volumeUnit }}</span>
            </div>

            <div class="cell volume_z">
                <h4>높이</h4>
                <span class="value">
                        {{ package.volume_z }}
                    </span>
                <span class="unit">{{ volumeUnit }}</span>
            </div>

            <div class="cell volume_weight">
                <h4>부피무게</h4>
                <span class="value">
                        {{ package.volume_weight }}
                    </span>
                <span class="unit">{{ unit }}</span>
            </div>

            <div class="cell apply_weight">
                <h4 uk-tooltip="적용무게란? 무게와 부피무게중 더 큰 값이 선택됩니다.">적용무게</h4>
                <span class="value">
                        {{ package.apply_weight }}
                    </span>
                <span class="unit">{{ unit }}</span>
            </div>

        </div>

        <!-- 버튼 -->
        <button
            class="uk-button uk-button-danger uk-button-small"
            v-on:click.stop="$parent.remove(index)"
            :disabled="disableRemoveBtn"
            title="REMOVE"
            type="button"
        >
            <i class="material-icons md-24">delete</i>
        </button>

    </div>


</template>

<script>
export default {
    props: {

        /**
         * 사용단위
         * - kg : kg, cm 사용
         * - lb : lb(파운드), in(인치) 사용
         */
        unit: {
            type: String,
            default: 'kg',
        },

        /**
         * 부피단위
         * - cm
         * - in
         */
        volumeUnit: {
            type: String,
            default: 'cm',
        },

        /**
         * index
         */
        index: {
            type: Number,
            default: null,
        },

        /**
         * 삭제버튼 비활성화
         */
        disableRemoveBtn: {
            type: Boolean,
            default: false,
        },

        /**
         * packages 정보
         *  - {weight: 1, volume_x: 1, volume_y: 1, volume_z: 1, volume_weight: 1, apply_weight: 1}
         */
        package: {
            type: Object,
            default: function () {
                return {
                    weight: null,
                    volume_x: null,
                    volume_y: null,
                    volume_z: null,
                    volume_weight: null,
                    apply_weight: null,
                };
            }
        }
    },
    data: function () {
        return {};
    },
    computed: {

        // 무게가 입력되었는지
        hasWeight() {
            return this.$parent.parseNumber(this.package.weight) > 0;
        },


    },
    watch: {},
    mounted: function () {

    },
    methods: {}
}
</script>

<style lang="scss" scoped>


.package {
    position: relative;
    text-align: center;
    border: 1px solid #999;
    background-color: #fff;
    margin-bottom: -1px;
    //margin-top: 20px;

    .cell {
        border-left: 1px solid #ddd;
        padding: 5px 0;
        width: calc(100% / 6);
        //flex-grow: 1;
        //flex-shrink: 1;

        h4 {
            font-weight: bold;
            font-size: 1rem;
            background-color: #fefefe;
            padding-bottom: 0.25rem;
            border-bottom: 1px solid #ddd;
            margin-bottom: 5px;

        }

        .value {
            font-size: 1.5rem;
            //font-style: italic;
        }

        .unit {
            color: #999;
            font-size: 1rem;
            font-style: normal;
        }
    }

    // 무게/부피글자 크기

    .weight,
    .volume_x,
    .volume_y,
    .volume_z {
        .value {
            color: #1e87f0;
        }
    }

    .volume_x {
        border-left: 5px double #ddd;
    }

    .volume_weight {
        .value {
            color: #999;
        }
    }


    .apply_weight {
        border-left: 5px double #ddd;

        .value {
            color: #000;
        }
    }

    // 마우스오버
    cursor: pointer;


}

// 무게 미입력 화면
.input-msg {
    width: 100%;
    padding: 1rem;
    border: 1px solid #999;
    background-color: #fff;

    color: #f0506e;
    font-size: 1.125rem;
    //font-weight: bold;
    text-align: center;

    cursor: pointer;

}
</style>